<span>{{ 'Settings::RedactionExistCategoryName' | abpLocalization : categoryNames }}</span>
